import React from 'react'
import styled from 'styled-components'

export enum AutocompleteType {
  email = 'email'
}
export interface ITextInputProps {
  placeholder?: string
  onChange: (value: string) => void
  value?: string
  readonly?: boolean
  disabled?: boolean
  id: string
  autoComplete?: AutocompleteType
  onBlur?: (event: React.FocusEvent<HTMLInputElement, Element>) => void
  onFocus?: (event: React.FocusEvent<HTMLInputElement, Element>) => void
}

const TextInput: React.FC<ITextInputProps> = ({
  placeholder,
  onChange,
  value,
  readonly,
  disabled,
  id,
  autoComplete,
  onBlur,
  onFocus
}) => {
  return (
    <Input
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={(event) => {
        onChange(event.target.value)
      }}
      readOnly={readonly}
      disabled={disabled}
      id={id}
      name={id}
      autoComplete={autoComplete || 'off'}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  )
}

const Input = styled.input`
  flex-grow: 1;
  font-style: normal;
  font-weight: ${({ theme }) => theme.weight.normal};
  font-size: ${({ theme }) => theme.size.small};
  line-height: 18px;
  background: transparent;

  &::placeholder {
    font-weight: ${({ theme }) => theme.weight.normal};
    font-size: ${({ theme }) => theme.size.small};
    font: ${({ theme }) => theme.font.default};
  }
`

export default TextInput
